import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spacer, UnauthorizedUserPage } from 'z-react-components';

import mapDispatchToProps from '../lib/MapDispatchToProps';
import * as SupportRequestStatuses from '../constants/SupportRequestStatuses';
import { PROFESSIONIST_GROUP_ID, STUDENT_GROUP_ID, TEACHER_GROUP_ID } from '../constants/UserGroups';

class UnauthorizedUserPageWrapper extends Component {
    getTitle() {
        const { userInfo } = this.props;
        if (userInfo && parseInt(userInfo.groupId, 10) === TEACHER_GROUP_ID && parseInt(userInfo.mail_ok, 10) === 1) {
            return 'Non ci sono ancora esercizi per la tua materia, ci dispiace.';
        } else if (userInfo && parseInt(userInfo.groupId, 10) === STUDENT_GROUP_ID) {
            return 'Crea verifiche è un sito solo per i docenti.';
        } else {
            return 'Non puoi accedere a questa risorsa protetta.';
        }
    }

    getMessage() {
        const { userInfo } = this.props;
        if (userInfo && parseInt(userInfo.groupId, 10) === TEACHER_GROUP_ID && parseInt(userInfo.mail_ok, 10) === 1) {
            return (
                <span>
                    <p>
                        {'Su Crea Verifiche non abbiamo ancora esercizi per la tua classe di concorso. '}
                        {this.renderSupportLink(true)}
                        {
                            ' per farci sapere per quali materie vorresti trovare esercizi su Crea Verifche o se hai bisogno di vedere esercizi per classi di concorso diversa dalla tua.'
                        }
                    </p>
                    <p>
                        {'Potresti trovare risorse utili per la tua materia su '}
                        {
                            <a href="https://zte.zanichelli.it/">
                                <img
                                    alt="zte_icon"
                                    src="https://s3-eu-west-1.amazonaws.com/z-react-components-assets/UnauthorizedTeacherPage/ZTE_scuola.png"
                                    style={{ width: 50 }}
                                />
                            </a>
                        }
                        {' o su '}
                        {
                            <a href="https://collezioni.scuola.zanichelli.it/">
                                <img
                                    alt="collezioni_icon"
                                    src="https://s3-eu-west-1.amazonaws.com/z-react-components-assets/UnauthorizedTeacherPage/collezioni.png"
                                    style={{ width: 80 }}
                                />
                            </a>
                        }
                        {' : se non conosci ancora questi due siti, prova a visitarli.'}
                    </p>
                </span>
            );
        } else if (userInfo && parseInt(userInfo.groupId, 10) === STUDENT_GROUP_ID) {
            return (
                <span>
                    <p>
                        {
                            'Devi essere registrato su myZanichelli come docente per entrare in questo sito, Crea Verifiche. Sei invece registrato come «studente».'
                        }
                    </p>
                    <p>
                        {'Se ti sei registrato come studente per sbaglio, e sei invece un docente, '}
                        {this.renderSupportLink(false)}
                        {' e ti aiuteremo a correggere l’errore.'}
                    </p>
                </span>
            );
        } else if (userInfo && parseInt(userInfo.groupId, 10) === PROFESSIONIST_GROUP_ID) {
            return (
                <span>
                    <p>
                        {
                            'Il Crea Verifiche è un ambiente pensato per i docenti, quindi è necessario essere registrati in myZanichelli come docenti per accedere.  Sei iscritto come «professionista».'
                        }
                    </p>
                    <p>
                        {'Se sei un docente e ritieni di aver diritto a vedere questa risorsa o vuoi segnalare un malfunzionamento, '}
                        {this.renderSupportLink(false)}
                        {'.'}
                    </p>
                </span>
            );
        } else if (parseInt(userInfo.mail_ok, 10) === 0) {
            return (
                <span>
                    <p>{"Per poter usare il Crea Verifiche occorre che il tuo rappresentante verifichi l'iscrizione."}</p>
                    <p>
                        {'Se sei già stato confermato o vuoi segnalare un malfunzionamento, '}
                        {this.renderSupportLink(false)}
                        {'.'}
                    </p>
                </span>
            );
        }
    }

    renderSupportLink(capitalized) {
        return (
            <a href="https://my.zanichelli.it/contattaci" target="_blank" rel="noopener noreferrer">
                {`${capitalized ? 'C' : 'c'}ontattaci`}
            </a>
        );
    }

    render() {
        const logo = './_assets/images/logo.svg';
        const bannerBackgrounColor = '#27a8ba';
        return (
            <span className="z-unauthorizeduserpagewrapper">
                <UnauthorizedUserPage bannerBackgroundColor={bannerBackgrounColor} message={this.getMessage()} logo={logo} title={this.getTitle()} />
            </span>
        );
    }
}

UnauthorizedUserPageWrapper.propTypes = {
    userInfo: PropTypes.object.isRequired
};

export class Unauthorized extends Component {
    render() {
        const { userInfo } = this.props;
        return (
            <span className="z-unauthorized">
                <UnauthorizedUserPageWrapper userInfo={userInfo} />
                <Spacer direction="v" size="40px" />
            </span>
        );
    }
}

Unauthorized.propTypes = {
    actions: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    supportRequestStatus: PropTypes.oneOf([SupportRequestStatuses.INITIAL_STATUS, SupportRequestStatuses.SUCCESS, SupportRequestStatuses.FAILURE]).isRequired,
    userInfo: PropTypes.object.isRequired,
    userName: PropTypes.string.isRequired
};

function mapStateToProps({ SupportRequestReducer, auth }) {
    return {
        isLoggedIn: auth.isLoggedIn,
        supportRequestStatus: SupportRequestReducer.status,
        userName: auth.user.loginId,
        userInfo: auth.user
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Unauthorized);
